
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/nodejs",
      function () {
        return require("private-next-pages/events/sdks/nodejs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/nodejs"])
      });
    }
  